import { render, staticRenderFns } from "./AssetCategoryEdtior.vue?vue&type=template&id=bf6eee7e&"
import script from "./AssetCategoryEdtior.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryEdtior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports